import * as Yup from "yup";

export const LoginSchema = Yup.object({

    user: Yup.string().required("Enter Your User Name"),
    password: Yup.string().required("Enter Your Password"),
});

export const ForgetPasswordSchema = Yup.object({

    // user: Yup.string().required("Enter Your User Name"),
    new_password: Yup.string().required("Enter New Password"),
    confirm_password: Yup.string().required("Enter Confirm Password").oneOf([Yup.ref('new_password')], "Passwords do not match")
    // .min(8, "Password must be at least 8 characters long")
    ,
});     